import { InputNumber } from "primereact/inputnumber";
import React, { useState } from "react";
import ReactQuill from "react-quill-new";
import { reactQuillModules } from "utils/constants";
import "react-quill-new/dist/quill.snow.css";

export interface FreeTextConfig {
  content: string;
  height?: number;
}

interface FreeTextEditorProps {
  config: FreeTextConfig;
  onConfigChange: (config: FreeTextConfig) => void;
}

const FreeTextEditor = ({ config, onConfigChange }: FreeTextEditorProps) => {
  const [value, setValue] = useState(config?.content ?? "");

  const handleChange = (content: string) => {
    setValue(content);
    onConfigChange({ content });
  };

  return (
    <div className="flex flex-column gap-3">
      <div className="flex flex-column gap-2 w-2">
        <label htmlFor="height">Height (px)</label>
        <InputNumber
          id="height"
          value={config.height ?? undefined}
          onChange={e => onConfigChange({ ...config, height: e.value ?? undefined })}
        />
      </div>
      <ReactQuill value={value} onChange={handleChange} modules={reactQuillModules} />
      <h4 className="border-bottom-1 pb-2 mb-2">Preview</h4>
      <div className="quill-rendered-content bg-white">
        <div dangerouslySetInnerHTML={{ __html: value }} />
      </div>
    </div>
  );
};

export default FreeTextEditor;
